import React from 'react';
import { Col, Row } from 'react-bootstrap';
import styles from './styles.module.css';

const UsageDashboard = () => {
  return (
    <Row className={styles.root} data-cy-id="Usage-Dashboard" noGutters>
      <Col> Dashboard </Col>
    </Row>
  );
};

export default UsageDashboard;
